import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex gap-4 items-center justify-center" }
const _hoisted_2 = { class: "inline-block w-72" }
const _hoisted_3 = { class: "inline-block w-72" }
const _hoisted_4 = { class: "sm:basis-1/6 sm:pr-10 pb-2" }
const _hoisted_5 = { class: "sm:basis-5/6" }
const _hoisted_6 = { class: "grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-9 gap-3" }
const _hoisted_7 = { class: "col-span-3 p-2 sm:p-4 h-40 sm:h-32 rounded-lg border border-gray-300 dark:border-gray-600 flex justify-center" }
const _hoisted_8 = { class: "flex items-center justify-center w-full" }
const _hoisted_9 = { class: "w-32 flex flex-col items-center justify-center" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "w-full text-xs" }
const _hoisted_13 = { class: "font-semibold text-gray-500 dark:text-white text-sm mb-2" }
const _hoisted_14 = {
  key: 0,
  class: "font-thin"
}
const _hoisted_15 = { class: "mb-2" }

import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import Heading from "@/components/Heading.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";
import { getTechnologyCategoryLabelForTechnologyType, getTechnologyTypeLabel, Product, ProductTechnology, Technology, technologyTypesByCategory } from "@/model";
import { useRoute } from "vue-router";
import Heading2 from "@/components/Heading2.vue";
import { computed, ref, Ref } from "vue";
import EditProductDialog from "./TechLandscape/EditProductDialog.vue";
import Button from "@/components/Button.vue";
import Hero from "@/components/Hero.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessUnitProductView',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();

const product: Ref<Product> = ref();
const productTechnologies: Ref<ProductTechnology[]> = ref([]);

async function loadData() {
  product.value = await pb.collection('products').getOne<Product>(route.params.id, {
    expand: 'businessUnit',
    sort: 'name',
    '$autoCancel': false,
  });

  productTechnologies.value = await pb.collection('product_technologies').getFullList<ProductTechnology>(null, {
    expand: 'technology',
    sort: 'technology.name',
    filter: `product = '${product.value.id}'`,
    '$autoCancel': false,
  });
}

;(
  ([__temp,__restore] = _withAsyncContext(() => loadData())),
  await __temp,
  __restore()
);

const categories = computed(() => {
  const categories: Record<string, {
    label: string,
    types: Record<string, {
      label: string,
      productTechnologies: ProductTechnology[],
    }>,
  }> = {};

  for (const productTechnology of productTechnologies.value) {
    const technology = productTechnology.expand!.technology!;
    const categoryLabel = getTechnologyCategoryLabelForTechnologyType(technology.type);
    const typeLabel = getTechnologyTypeLabel(technology.type);

    if (!categories[categoryLabel]) {
      categories[categoryLabel] = {
        label: categoryLabel,
        types: {},
      };
    }

    if (!categories[categoryLabel].types[typeLabel]) {
      categories[categoryLabel].types[typeLabel] = {
        label: typeLabel,
        productTechnologies: [],
      };
    }

    categories[categoryLabel].types[typeLabel].productTechnologies.push(productTechnology);
  }

  return Object.values(categories).sort((a, b) => {
    // sort categories
    const a1 = technologyTypesByCategory.indexOf(technologyTypesByCategory.find(({ category }) => category === a.label));
    const b1 = technologyTypesByCategory.indexOf(technologyTypesByCategory.find(({ category }) => category === b.label));

    return a1 - b1;
  }).map(category => {
    // and sort types in each category
    const sortedTypes = technologyTypesByCategory.find(({ category: cat }) => cat === category.label).types;

    return {
      ...category,
      types: Object.values(category.types).sort((a, b) => {
        return sortedTypes.indexOf(a.label) - sortedTypes.indexOf(b.label);
      }),
    };
  });
});

function getLogoUrl(technology: Technology): string {
  return pb.files.getUrl(technology, technology.logo);
}

const isEditing: Ref<bool> = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, {
      subtitle: product.value.expand!.businessUnit!.name
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(product.value.name), 1)
      ]),
      _: 1
    }, 8, ["subtitle"]),
    _createVNode(Divider),
    _createVNode(Content, null, {
      default: _withCtx(() => [
        (isEditing.value)
          ? (_openBlock(), _createBlock(EditProductDialog, {
              key: 0,
              product: product.value,
              onClose: _cache[0] || (_cache[0] = ($event: any) => {isEditing.value = false; loadData();})
            }, null, 8, ["product"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Button, {
              label: "Manage technologies",
              outline: "",
              icon: "edit",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {isEditing.value = true;})
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: { name: 'product_print', params: { id: _unref(route).params.id }},
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createVNode(Button, {
                  label: "Generate image",
                  outline: "",
                  icon: "print"
                })
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        (product.value.description.length > 0)
          ? (_openBlock(), _createBlock(Hero, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(product.value.description), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createVNode(Heading, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(category.label), 1)
              ]),
              _: 2
            }, 1024),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.types, (type, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
          'flex flex-col sm:flex-row',
           idx > 0 ? 'border-t border-gray-200 dark:border-gray-700 pt-4' : '',
      ])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(Heading2, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(type.label), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.productTechnologies, (productTechnology) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (productTechnology.expand!.technology.simpleicon)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: `https://cdn.simpleicons.org/${productTechnology.expand!.technology.simpleicon}`,
                                  alt: `Logo of ${productTechnology.expand!.technology.name}`,
                                  class: "mb-2 w-12 h-12 object-contain"
                                }, null, 8, _hoisted_10))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (productTechnology.expand!.technology.logo)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: getLogoUrl(productTechnology.expand!.technology),
                                        alt: `Logo of ${productTechnology.expand!.technology.name}`,
                                        class: "mb-1 w-10 h-10 object-contain"
                                      }, null, 8, _hoisted_11))
                                    : _createCommentVNode("", true)
                                ], 64))
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_router_link, {
                              to: { name: 'technology', params: { id: productTechnology.technology }}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("h3", _hoisted_13, [
                                  _createTextVNode(_toDisplayString(productTechnology.expand!.technology.name) + " ", 1),
                                  (productTechnology.version)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(productTechnology.version), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            _createElementVNode("p", _hoisted_15, _toDisplayString(productTechnology.comment || 'no comment'), 1)
                          ])
                        ])
                      ]))
                    }), 256))
                  ])
                ])
              ], 2))
            }), 256))
          ], 64))
        }), 256))
      ]),
      _: 1
    })
  ], 64))
}
}

})